import React from 'react';
import PwdEditablePopup from '../pwdEditablePopup/PwdEditablePopup';
import UserEditablePopup from '../userEditablePopup/UserEditablePopup';

export const columnSetter = (dataReloadFunc, deleteFunc, auths) => {
  const columns = [
    {
      Header: '사용자 정보',
      columns: [
        {
          Header: <div></div>,
          accessor: 'index',
        },
        {
          Header: '아이디',
          accessor: 'userId',
        },
        {
          Header: '부서',
          accessor: 'dept',
        },
        {
          Header: '이름',
          accessor: 'userNm',
        },
        {
          Header: '권한',
          accessor: 'authNm',
        },
        {
          Header: '연락처',
          accessor: 'tel',
        },
        {
          id: 'smsFlag',
          Header: () => (
            <>SMS수신여부</>
          ),
          Cell: ({ row }) => (
            <span>{row.original.userIdx === 1 ? '-' : row.original.smsFlag === 0 ? '아니오' : '예'}</span>
          ),
        },
        {
          Header: '장치그룹',
          accessor: 'moduleGroupIdx',
        },
        {
          Header: '등록자',
          accessor: 'rgstId',
        },
        {
          Header: '등록일',
          accessor: 'rgstDt',
        },
        {
          id: 'editButton',
          Header: () => (
            <>
            </>
          ),
          Cell: ({ row }) => (
            <UserEditablePopup user={row.original}
                              dataReloadFunc={dataReloadFunc}
                              auths={auths}>
              <div>
                <button className="table-search-submit btn btn-info">수정</button>
              </div>
            </UserEditablePopup>
          ),
        },
        {
          id: 'pwdButton',
          Header: () => (
            <>
            </>
          ),
          Cell: ({ row }) => (
            <PwdEditablePopup user={row.original} 
                              dataReloadFunc={dataReloadFunc}>
              <div>
                <button className="table-search-submit btn btn-info">비밀번호 변경</button>
              </div>
            </PwdEditablePopup>
          ),
        },
        {
          id: 'deleteButton',
          Header: () => (
            <>
            </>
          ),
          Cell: ({ row }) => (
            <div>
              <button className="table-search-submit btn btn-info" 
                      onClick={() => {deleteFunc(row.original.userIdx)}}>
                삭제
              </button>
            </div>
          ),
        },
      ],
    },
  ];

  return columns;
};